import React from 'react';
import ChatWithAI from './ChatWithAI';
import BasicButtons from './BasicButtons.jsx'; // Adjust the path accordingly

function App() {
  return (
    <div className="App">
      <ChatWithAI />
    </div>
  );
}

export default App;